import { faCashRegister, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'
import { GridColDef } from '@mui/x-data-grid-pro'
import { Link, Stack, Typography } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import { PasserByBillDocumentItemFragment, PasserByBillItemFragment } from 'src/api/api.generated'
import { BillData } from '../creation/bill-creation-modal'
import getFiscalTypeDescription from 'src/app/pages/accounting/documents/documents-utils'
import { Action } from 'src/app/components/data-grid-action-cell-item'

export const usePasserbyBillColumns = (
  onOpenOtherActionsClick: (element: React.MouseEvent<HTMLButtonElement, MouseEvent>, passerbyBill: BillData) => void,
  onPasserbyBillChargeEditClick: (passerbyBillId: string) => void,
  setCheckoutDocumentId: (documentId: string) => void,
): GridColDef[] => {
  const { t } = useTranslation()
  return [
    {
      field: 'accountHolder',
      headerName: t('pms.booking.passerby-bill.list_header.accountholder'),
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Link style={{ textDecoration: 'none', fontWeight: 'bold' }} onClick={() => onPasserbyBillChargeEditClick(params.row._id)}>
            {params.row.owner.name}
          </Link>
        )
      },
    },
    {
      field: 'description',
      headerName: t('pms.booking.passerby-bill.list_header.description'),
      flex: 1,
      minWidth: 120,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'creationDate',
      headerName: t('pms.booking.passerby-bill.list_header.creation-date'),
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'total',
      headerName: t('pms.booking.passerby-bill.list_header.total'),
      flex: 1,
      minWidth: 80,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'document',
      headerName: t('pms.booking.passerby-bill.list_header.document'),
      flex: 1,
      minWidth: 80,
      disableColumnMenu: true,
      sortable: false,
      hideable: true,
      renderCell: (params) => {
        const document = params.row.document as PasserByBillDocumentItemFragment
        return (
          <Stack direction="column">
            {document?.fiscalType && <Typography variant="caption">{getFiscalTypeDescription(document.fiscalType, t).toUpperCase()}</Typography>}
            {document?._id && document._id !== null ? (
              <Link onClick={() => (document?._id && document._id !== null ? setCheckoutDocumentId(document._id) : undefined)}>{document?.numberExtended}</Link>
            ) : (
              ''
            )}
          </Stack>
        )
      },
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t('commons.table_actions'),
      getActions: (params) => {
        const row = params.row as PasserByBillItemFragment

        return [
          <Action icon={faCashRegister} label="Edit" onClick={() => onPasserbyBillChargeEditClick(params.row.id)} />,
          <Action
            icon={faEllipsisVertical}
            label="Delete"
            onClick={(event) => {
              if (row.description && row.description !== null && row.owner?._id && row.owner?._id !== null)
                onOpenOtherActionsClick(event as React.MouseEvent<HTMLButtonElement, MouseEvent>, {
                  billId: row._id,
                  description: row.description,
                  ownerId: row.owner?._id,
                  productionLength: row.productionLength,
                })
            }}
            color="inherit"
          />,
        ]
      },
    },
  ]
}
